/** Mock IDs to be used in mockIds url parameter */
export enum MockIds {
  /** Use the default configuration defined in the code base - This will be fetched from the local version **of the bff** */
  localConfiguration = 'localConfiguration',
  /** Force commercial mode */
  commercial = 'commercial',
  /** Allow customizing a configuration via localstorage */
  customConfiguration = 'customConfiguration',
}

export const mockIdsParam = 'mockIds';

export const parseMockIds = (mockIdsValue?: string | null): Set<string> =>
  new Set((mockIdsValue ?? '').split('-'));

export const formatMockIds = (mockIds: Set<string>) =>
  Array.from(mockIds.values()).join('-');
